import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container, PageFade, Reveal } from "../components/site/Motion";
import { SECTORS } from "../data/sectors";

export default function Secteurs() {
  return (
    <PageFade>
      <section className="wave-bg">
        <Container className="py-16 lg:py-20">
          <Reveal className="max-w-3xl space-y-6">
            <p className="eyebrow">La finance selon votre réalité</p>
            <h1 className="text-4xl leading-[1.06] sm:text-5xl lg:text-6xl">Obtenez plus d'informations <span className="text-[#650D23]">sur votre métier.</span></h1>
            <p className="text-lg text-[#242020]/80">Sélectionnez votre secteur pour découvrir les options d'assurance, de placements et d'optimisation fiscale adaptées à votre réalité.</p>
          </Reveal>
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SECTORS.map((s, i) => {
              const I = s.icon;
              return (
                <Reveal key={s.slug} delay={(i % 3) * 0.08}>
                  <Link to={`/secteurs/${s.slug}`} data-testid={`sector-card-${s.slug}`} className="card-soft group flex h-full flex-col overflow-hidden">
                    <div className="relative">
                      <img src={s.cover} alt={s.name} className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      <span className="absolute -bottom-8 left-1/2 flex h-16 w-16 -translate-x-1/2 items-center justify-center rounded-full border-4 border-[#FFFDFB] bg-[#650D23] text-[#FFFDFB]">
                        <I className="h-6 w-6" strokeWidth={1.5} />
                      </span>
                    </div>
                    <div className="flex flex-1 flex-col items-center px-6 pb-7 pt-12 text-center">
                      <h2 className="text-2xl">{s.name}</h2>
                      <p className="mt-3 flex-1 text-sm text-[#242020]/65">{s.summary}</p>
                      <span className="mt-5 flex h-10 w-10 items-center justify-center rounded-full bg-[#650D23] text-[#FFFDFB] transition-transform group-hover:translate-x-1">
                        <ArrowRight className="h-4 w-4" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </Container>
      </section>
    </PageFade>
  );
}
